import RoomImageCarousel, { RoomImageCarouselProps } from './roomImageCarousel'

// No logic — passthrough kept for the two-file pattern.
const RoomImageCarouselWrapper = (props: RoomImageCarouselProps) => {
    return <RoomImageCarousel {...props} />
}

export { RoomImageCarouselWrapper }
export type { RoomImageCarouselProps }
export default RoomImageCarouselWrapper
